import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components'
import { CommonGAssets } from '@hhgtech/hhg-components/gAssets'

const siteWideBg = CommonGAssets.getAssetPath('sitewide/vn-public-desktop.png')
export const StyledsiteWideContainer = styled.div<{ bgColor: string }>`
  position: relative;
  display: flex;
  overflow: hidden;
  align-items: center;
  background-color: ${(props) => props.bgColor || '#284a75'};
  background-position: center;
  background-size: cover;
  transition: height 0.25s;
  &[data-is-mobile='true'] {
    justify-content: flex-start;
  }
  &[data-is-mobile='false'] {
    justify-content: center;
  }

  &[data-is-collapse='false'] {
    height: 64px;
  }
  &[data-is-collapse='true'] {
    height: 0;
  }

  ${MediaQueries.mbDown} {
    &[data-is-collapse='false'] {
      height: 48px;
    }
  }

  &[data-is-vn-public-day='true'] {
    background-color: ${theme.colors.red900};
    ${MediaQueries.mbDown} {
      overflow: hidden;
    }
    ${MediaQueries.mbUp} {
      background-image: url(${siteWideBg});
      background-repeat: no-repeat;
      background-size: cover;

      .vn-bg {
        display: none;
      }
    }
  }

  .banner-full {
    object-fit: cover;
    height: 100%;
  }

  & > a {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    text-decoration: none;
  }

  > a + .site-wide-content {
    width: 100%;
  }

  .content {
    padding-right: 48px;
    color: white;
    a {
      color: white;
    }
    &[data-is-mobile='true'] {
      font-size: 14px;
    }
    ${MediaQueries.mbDown} {
      line-height: 18px;
    }
  }
  .close-icon {
    position: absolute;
    right: 0px;
    width: 64px;
    height: 64px;
    padding: 0 20px;
    cursor: pointer;
  }

  [data-event-category] {
    * {
      pointer-events: none !important;
    }
  }
`

export const StyledIcon = styled.div`
  max-width: 100px;
  margin-right: 16px;
  .image-wrapper {
    display: inline-block;
    overflow: hidden;
    max-width: 100px;
    padding: 8px 0 4px 16px;
    img {
      width: 64px;
      height: 64px;
      object-fit: contain;
      &[data-is-mobile='true'] {
        width: 52px;
        height: 52px;
      }
    }
  }
`
